import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { SiteWrapper } from 'src/app';
import React, { Suspense } from 'react';
import { Loader } from 'src/redesign/components/Loader';

const WidgetsPage = React.lazy(() =>
  import('src/modules/sites/widgets').then((module) => ({ default: module.Widgets })),
);

const TeamInviteLoadedPage = React.lazy(() =>
  import('src/redesign/pages/TeamInvitePage').then((module) => ({
    default: module.TeamInvitePage,
  })),
);

export const SiteRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        exact
        path={`${path}/:site_id/widgets`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props}>
              <WidgetsPage />
            </SiteWrapper>
          </Suspense>
        )}
      />
      <Route
        exact
        path={`${path}/:site_id/team`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props}>
              <TeamInviteLoadedPage />
            </SiteWrapper>
          </Suspense>
        )}
      />
    </Switch>
  );
};
